<section class="section banner">
    <div [@bannerTrigger] class="container">
        <div class="section-box-banner">
            <div class="content">
                <div>
                    <!-- <h1>Hola, mi nombre es</h1> -->
                    <h1>Hello! My name is</h1>
                </div>
                <div class='banner-title'>
                    <h2 class="text-capitalize">Siva prasad N.</h2>
                    <h3 class="text-capitalize">Software developer</h3>
                </div>
                <div class='banner-description'>

                    <p  class="mt-4">I am a passionate software developer with <span class="underline"> 1.2 year </span>of hands-on experience building dynamic, responsive web applications. Specializing in technologies like <span class="underline"> HTML, CSS, Bootstrap, JavaScript, 
                        Vue.js, Vuex, Nuxt.js</span>, I have also broadened my skill set through personal projects in
                        <span class="underline">React and Node.js</span>.This experience has strengthened my understanding of component-based
                        architecture and full-stack development. Throughout my career, I’ve contributed to more than five
                        live projects, including a booking engine, demonstrating my ability to adapt quickly and deliver userfocused, high-quality solutions. I am enthusiastic about continuously expanding my knowledge and
                        leveraging new tools and frameworks to push the boundaries of software development.</p>
                </div>
            </div>
            <div class="div-btn-banner">
                <a (click)='analyticsService.sendAnalyticEvent("click_send_mail", "banner", "email")' href="mailto:connectwithsivaprasad@gmail.com" target="_black" class="main-btn text-capitalize">
                    get in touch
                </a>
            </div>
        </div>
    </div>
</section>
